import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { apiErr } from "@/lib/format";
import { BarcodeIcon } from "@phosphor-icons/react";

/**
 * <BarcodeScanInput /> — campo de escaneo compatible con lectores USB (emulan teclado y
 * envían Enter al final). Al presionar Enter busca el producto por código de barras
 * (GET /api/products/by-barcode/{code}) y llama onFound(producto).
 */
export default function BarcodeScanInput({ onFound, placeholder = "Escanear código de barras…", testid = "barcode-scan", autoFocus = false }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const onKeyDown = async (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    const c = code.trim();
    if (!c) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/products/by-barcode/${encodeURIComponent(c)}`);
      onFound && onFound(data);
      setCode("");
    } catch (err) {
      toast.error(apiErr(err));
      setCode("");
    } finally {
      setBusy(false);
      ref.current?.focus();
    }
  };

  return (
    <div className="relative">
      <BarcodeIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-agro-yellow" />
      <input
        ref={ref}
        value={code}
        autoFocus={autoFocus}
        disabled={busy}
        onChange={(e) => setCode(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        data-testid={testid}
        className="w-full bg-app border border-agro-yellow/40 rounded-md pl-9 pr-3 py-2 text-sm focus:border-agro-yellow font-mono"
      />
    </div>
  );
}
